import Alert from "components/Alert/Alert";

export default Alert